export const MODERATOR_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },

  { slug: 'title', name: 'Sales' },
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },

  { slug: 'title', name: 'Operations' },
  { slug: 'link', name: 'Mark Returns', href: '/shipping/returns', icon: 'cilRefund' },
  { slug: 'link', name: 'Barcodes', href: '/barcodes', icon: 'cilBarcode' },

  {
    slug: 'dropdown',
    name: 'Reports',
    icon: 'cilReport',
    elements: [
      { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
      { slug: 'link', name: 'POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
      { slug: 'link', name: 'Department Report', href: '/departmentreport', icon: 'cilGrid' },
      { slug: 'link', name: 'Branch Report', href: '/branchreport', icon: 'cilChartLine' },
      { slug: 'link', name: 'Agentwise Report', href: '/agentwise_report', icon: 'cilUserChart' },
      { slug: 'link', name: 'Telesales Report', href: '/telesales_report', icon: 'cilPhoneChart' },
      { slug: 'link', name: 'Download Reports', href: '/reports', icon: 'cilCloudDownload' },
    ],
  },
]
